import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-pop-up-notification',
    templateUrl: './pop-up-notification.component.html',
    styleUrls: ['./pop-up-notification.component.css'],
    standalone: false,
})
export class PopUpNotificationComponent implements OnInit {
    @ViewChild('notificationContainer') notificationContainer: ElementRef;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            message: string;
            message2: string;
            closeButton: string;
            hideTimeout: number;
        },
        private dialogRef: MatDialogRef<PopUpNotificationComponent>
    ) {}

    ngOnInit(): void {
        if (this.data.hideTimeout) {
            setTimeout(() => {
                this.closeNotification();
            }, this.data.hideTimeout);
        }
        if (!this.data.closeButton) {
            this.data.closeButton = 'dlg.notification.close-button';
        }
    }

    closeNotification() {
        this.dialogRef.close();
    }
}
